import React, { useLayoutEffect, useRef, useState } from "react"

export default function OrderComment({ onChange }) {
  const [isCommentOpen, setIsCommentOpen] = useState(false)
  const textareaElRef = useRef(null)

  const onInput = (e) => {
    e.target.style.height = 0
    e.target.style.height = e.target.scrollHeight + "px"
  }

  useLayoutEffect(() => {
    setTimeout(() => {
      if (!isCommentOpen) {
        textareaElRef.current.style.display = "none"
      } else {
        textareaElRef.current.setAttribute(
          "style",
          "height:" +
            textareaElRef.current.scrollHeight +
            "px;overflow-y:hidden;display:block;"
        )
        textareaElRef.current.addEventListener("input", onInput, false)
      }
    }, 0)
  }, [isCommentOpen, textareaElRef])

  return (
    <div className="order-comment">
      <div
        className="order-comment__btn flex-c"
        onClick={() => setIsCommentOpen(!isCommentOpen)}
      >
        {isCommentOpen ? (
          <span className="icon-stop" />
        ) : (
          <svg className="icon-anchor">
            <use xlinkHref="#anchor" />
          </svg>
        )}
        {window.labels.checkout.fields.deliveryCommentPlaceholder}
      </div>

      {/* {isCommentOpen && ( */}
      <textarea
        id=""
        rows="1"
        ref={textareaElRef}
        className="order-comment__textarea"
        style={{ height: "0" }}
        onChange={onChange}
      ></textarea>
      {/* )} */}
    </div>
  )
}
